import gql from 'graphql-tag'
import { ELEMENT_FIELDS } from './catalogQuery'

export const QUIZ_SECTIONS = gql`
  query quiz_sections(
    $shadesWhere: SectionWhereInput
    $typesWhere: SectionWhereInput
    $first: Int
  ) {
    shades: sections(where: $shadesWhere, first: $first) {
      nodes {
        id
        bx_id
        name
        description
        previewPicture {
          id
          url
        }

        childSections {
          id
          bx_id
          name
          description

          previewPicture {
            id
            url
          }
        }
      }
    }
    types: sections(where: $typesWhere, first: $first) {
      nodes {
        id
        bx_id
        name
        description

        propertyValuesRelation {
          id
          property {
            id
            code
          }
          targetFiles {
            id
            url
          }
        }

        childSections {
          id
          bx_id
          name
          description

          propertyValuesRelation {
            id
            property {
              id
              code
            }
            targetFiles {
              id
              url
            }
          }
        }
      }
    }
  }
`

export const QUIZ_RESULT = gql`
  query quiz_result($where: ElementWhereInput!) {
    element(where: $where) {
      id
      name
      propertyValuesRelation {
        property {
          id
          code
        }
        id
        targetElement {
          id
          bx_id
          code
          name
          priceBase
        }
        targetElements {
          id
          name
          bx_id
          previewPicture {
            id
            url
          }
          detailPicture {
            id
            url
          }
          propertyValuesEnum {
            property {
              id
              code
            }
            id
            value
          }

          parentProduct {
            ...elementFields
          }
        }
      }
    }
  }
  ${ELEMENT_FIELDS}
`
